import React from 'react';
import 'moment/locale/it';
import { UIModal, UIModalBody, UIModalHeader, UiModalInternal } from '../../utilities/Modal';
import { UIPageHeader } from '../../utilities/Headers';
import UITypography from '../../utilities/Typography';
import { useOffices } from '../../../hooks/Offices/useOffices';
import UITable, { UITableHeadCell } from '../../utilities/Table';
import { Box } from '@mui/material';

const ModalOfficeCitiesConnectedAdmin = ({ modalOpen, handleModalClose, city }) => {
  const { onListOfficesAdminPaginated } = useOffices();

  const handleInternalClose = () => {
    handleModalClose();
  };

  const prepareValues = (offices) =>
    offices?.map((office) => {
      return {
        office: office,
        NameEl: <Box>{office?.name}</Box>
      };
    });

  const columns = [
    {
      name: <UITableHeadCell title={'Nome'} />,
      value: 'NameEl',
      size: 80
    }
  ];

  return (
    <UIModal open={modalOpen} onClose={handleInternalClose} allowFullScreen={true}>
      <UiModalInternal
        onClose={handleInternalClose}
        isLoading={false}
        containerSx={{
          bgcolor: '#FFF'
        }}
      >
        <UIModalHeader>
          <UIPageHeader
            title={'Cliniche collegate ' + city?.name}
            sx={{
              textAlign: 'center'
            }}
          />

          <UITypography
            variant={'Oxygen400'}
            title={'Lista delle cliniche collegate alla città di ' + city?.name}
            sxCustom={{
              m: '0px 10px 5px 10px',
              textAlign: 'center'
            }}
          />
        </UIModalHeader>
        <UIModalBody>
          <UITable
            columns={columns}
            prepareValues={prepareValues}
            enableSearch={false}
            infiniteScrollEndMessage={'Non ci sono altre cliniche da mostrare'}
            infiniteScrollFunction={onListOfficesAdminPaginated}
            enableCustomFilters={true}
            filtersData={{
              city_id: city?.id
            }}
            tableHeight={'calc(100vh - 450px)'}
            muiTableBodyRowProps={(data) => {
              return {
                sx: {
                  bgcolor: data?.row?.original?.date ? '#FDF2B5' : '',
                  p: 0,
                  '& td': data?.row?.original?.date
                    ? {
                        p: '5px 20px'
                      }
                    : {}
                }
              };
            }}
          />
        </UIModalBody>
      </UiModalInternal>
    </UIModal>
  );
};
export default ModalOfficeCitiesConnectedAdmin;
